enum enRoles {
  sysAdmin = 'sysAdmin',
  admin = 'admin',
  user = 'user',
  doctor = 'doctor'
}

export default enRoles;